import { render, staticRenderFns } from "./ClientSsoTab.vue?vue&type=template&id=568be22c"
import script from "./ClientSsoTab.vue?vue&type=script&lang=js"
export * from "./ClientSsoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports